<mat-card class="cur-card">
    <mat-card-header>
        <mat-card-title>承認情報</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="tankatableregistrationManageInfoForm">
            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <!-- 承認状態 -->
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[13%] tw-lg:max-w-[full]">
                    <mat-label>ステータス</mat-label>
                    <input matInput readonly="true" formControlName="approvalstatus" class="font-color-display-only"
                        autocomplete="off" disabled />
                </mat-form-field>
            </div>

            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <!-- 登録部署 -->
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-lg:max-w-[full]">
                    <mat-label>登録部署</mat-label>
                    <input matInput readonly="true" formControlName="regDepartmentname" class="font-color-display-only"
                        autocomplete="off" disabled />
                </mat-form-field>

                <!-- 登録者 -->
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-lg:max-w-[full]">
                    <mat-label>登録者</mat-label>
                    <input matInput readonly="true" formControlName="registrantname" class="font-color-display-only"
                        autocomplete="off" disabled />
                </mat-form-field>

                <!-- 登録日時 -->
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-lg:max-w-[full]">
                    <mat-label>登録日時</mat-label>
                    <input matInput readonly="true" formControlName="regDateTime" class="font-color-display-only"
                        autocomplete="off" disabled />
                </mat-form-field>
            </div>

            <div
                class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
                <!-- 承認部署 -->
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-lg:max-w-[full]">
                    <mat-label>承認部署</mat-label>
                    <input matInput readonly="true" formControlName="apprvDepartmentname"
                        class="font-color-display-only" autocomplete="off" disabled />
                </mat-form-field>

                <!-- 承認者 -->
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-lg:max-w-[full]">
                    <mat-label>承認者</mat-label>
                    <input matInput readonly="true" formControlName="approvername" class="font-color-display-only"
                        autocomplete="off" disabled />
                </mat-form-field>

                <!-- 承認日時 -->
                <mat-form-field appearance="fill"
                    class="input-form tw-flex tw-flex-row tw-box-border tw-grow tw-shrink tw-basis-full tw-max-w-[28%] tw-lg:max-w-[full]">
                    <mat-label>承認日時</mat-label>
                    <input matInput readonly="true" formControlName="apprvDateTime" class="font-color-display-only"
                        autocomplete="off" disabled />
                </mat-form-field>
            </div>
        </form>
    </mat-card-content>
</mat-card>